import type { HeadingComponent } from './Heading.d';
import React from 'react';
import { Element } from '../Element';

export const Heading: HeadingComponent = ({
	as,
	...otherProps
}) => (
	<Element
		{...otherProps}
		as={as || 'h3'}
	/>
);

export const H1: HeadingComponent = ({
	as: _overridden,
	...otherProps
}) => <Heading as='h1' {...otherProps}/>;

export const H2: HeadingComponent = ({
	as: _overridden,
	...otherProps
}) => <Heading as='h2' {...otherProps}/>;

export const H3: HeadingComponent = ({
	as: _overridden,
	...otherProps
}) => <Heading as='h3' {...otherProps}/>;

export const H4: HeadingComponent = ({
	as: _overridden1,
	...otherProps
}) => <Heading as='h4' {...otherProps}/>;

export const H5: HeadingComponent = ({
	as: _overridden,
	...otherProps
}) => <Heading as='h5' {...otherProps}/>;

export const H6: HeadingComponent = ({
	as: _overridden,
	...otherProps
}) => <Heading as='h6' {...otherProps}/>;
